import {
  faBox,
  faCheck,
  faFilter,
  faInfoCircle,
  faPen,
  faPlus,
  faSearch,
  faTimes,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import "./../styles/gestionArticle.css";

const articlesMock = [
  {
    id: "C349",
    produit: "Imprimante HP M479fdn 1",
    marque: "Laser jet pro Premium",
    categorie: "Informatique",
    prix: "40,000 FCFA",
    stock: 15,
    description: "Imprimante haute performance pour environnements exigeants",
    specifications: [
      "Résolution: 1200x1200 dpi",
      "Vitesse: 28 ppm",
      "Connectivité: WiFi, Ethernet, USB",
    ],
  },
  // ... autres articles avec le même format
];

export default function ArticleDashboard() {
  const [articles, setArticles] = useState(articlesMock);
  const [selectedArticle, setSelectedArticle] = useState(articles[0]);
  const [searchTerm, setSearchTerm] = useState("");
  const [marqueFilter, setMarqueFilter] = useState("Tous");
  const [categorieFilter, setCategorieFilter] = useState("Tous");
  const [showModal, setShowModal] = useState(false);
  const [currentArticle, setCurrentArticle] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  // Fonctionnalité de filtrage
  const filteredArticles = articles.filter((article) => {
    const matchesSearch =
      article.produit.toLowerCase().includes(searchTerm.toLowerCase()) ||
      article.id.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesMarque =
      marqueFilter === "Tous" || article.marque === marqueFilter;
    const matchesCategorie =
      categorieFilter === "Tous" || article.categorie === categorieFilter;
    return matchesSearch && matchesMarque && matchesCategorie;
  });

  // Fonctionnalité de suppression
  const handleDelete = (id) => {
    if (window.confirm("Voulez-vous vraiment supprimer cet article ?")) {
      setArticles(articles.filter((article) => article.id !== id));
      if (selectedArticle?.id === id) {
        setSelectedArticle(articles.length > 1 ? articles[0] : null);
      }
    }
  };

  // Fonctionnalité d'ajout
  const handleAdd = () => {
    setIsEditing(false);
    setCurrentArticle({
      id: `C${
        Math.max(...articles.map((a) => parseInt(a.id.substring(1)))) + 1
      }`,
      produit: "",
      marque: "",
      categorie: "",
      prix: "",
      stock: 0,
      description: "",
      specifications: [],
    });
    setShowModal(true);
  };

  // Fonctionnalité d'édition
  const handleEdit = (article) => {
    setIsEditing(true);
    setCurrentArticle({ ...article });
    setShowModal(true);
  };

  // Fonctionnalité de sauvegarde
  const handleSave = () => {
    if (isEditing) {
      setArticles(
        articles.map((a) => (a.id === currentArticle.id ? currentArticle : a))
      );
    } else {
      setArticles([...articles, currentArticle]);
    }
    setShowModal(false);
    setSelectedArticle(currentArticle);
  };

  // Fonctionnalité d'ajout de spécification
  const addSpecification = () => {
    setCurrentArticle({
      ...currentArticle,
      specifications: [...currentArticle.specifications, ""],
    });
  };

  // Fonctionnalité de suppression de spécification
  const removeSpecification = (index) => {
    setCurrentArticle({
      ...currentArticle,
      specifications: currentArticle.specifications.filter(
        (_, i) => i !== index
      ),
    });
  };

  // Fonctionnalité de modification de spécification
  const updateSpecification = (index, value) => {
    const newSpecs = [...currentArticle.specifications];
    newSpecs[index] = value;
    setCurrentArticle({
      ...currentArticle,
      specifications: newSpecs,
    });
  };

  return (
    <div className="container-fluid p-4 bg-light">
      {/* En-tête */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="mb-0">
            <FontAwesomeIcon icon={faBox} className="me-2 text-primary" />
            Gestion des Articles
          </h4>
          <small className="text-muted">
            {filteredArticles.length} article(s) • {articles.length} au total
          </small>
        </div>
        <button className="btn btn-primary" onClick={handleAdd}>
          <FontAwesomeIcon icon={faPlus} className="me-2" />
          Nouvel Article
        </button>
      </div>

      {/* Barre de recherche et filtres */}
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <h5 className="card-title mb-3">
            <FontAwesomeIcon icon={faSearch} className="me-2" />
            Rechercher...
          </h5>
          <div className="row g-3">
            <div className="col-md-4">
              <div className="input-group">
                <span className="input-group-text bg-white">
                  <FontAwesomeIcon icon={faSearch} />
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nom ou ID..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="input-group">
                <span className="input-group-text bg-white">
                  <FontAwesomeIcon icon={faFilter} />
                </span>
                <select
                  className="form-select"
                  value={marqueFilter}
                  onChange={(e) => setMarqueFilter(e.target.value)}
                >
                  {["Tous", ...new Set(articles.map((a) => a.marque))].map(
                    (marque, i) => (
                      <option key={i} value={marque}>
                        Marque: {marque}
                      </option>
                    )
                  )}
                </select>
              </div>
            </div>
            <div className="col-md-4">
              <div className="input-group">
                <span className="input-group-text bg-white">
                  <FontAwesomeIcon icon={faFilter} />
                </span>
                <select
                  className="form-select"
                  value={categorieFilter}
                  onChange={(e) => setCategorieFilter(e.target.value)}
                >
                  {["Tous", ...new Set(articles.map((a) => a.categorie))].map(
                    (cat, i) => (
                      <option key={i} value={cat}>
                        Catégorie: {cat}
                      </option>
                    )
                  )}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contenu principal */}
      <div className="row">
        {/* Liste des articles */}
        <div className="col-lg-8">
          <div className="card shadow-sm">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>ID</th>
                      <th>Produit</th>
                      <th>Marque</th>
                      <th>Catégorie</th>
                      <th>Stock</th>
                      <th>Prix</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredArticles.map((article) => (
                      <tr
                        key={article.id}
                        onClick={() => setSelectedArticle(article)}
                        className={
                          selectedArticle?.id === article.id
                            ? "table-primary"
                            : ""
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <td className="fw-bold">{article.id}</td>
                        <td>{article.produit}</td>
                        <td>{article.marque}</td>
                        <td>
                          <span
                            className={`badge bg-${
                              article.categorie === "Informatique"
                                ? "info"
                                : article.categorie === "Bureautique"
                                ? "warning text-dark"
                                : "secondary"
                            }`}
                          >
                            {article.categorie}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`badge ${
                              article.stock > 0 ? "bg-success" : "bg-danger"
                            }`}
                          >
                            {article.stock}
                          </span>
                        </td>
                        <td className="fw-bold">{article.prix}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-danger me-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDelete(article.id);
                            }}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(article);
                            }}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Détails de l'article */}
        <div className="col-lg-4">
          {selectedArticle ? (
            <div className="card shadow-sm h-100">
              <div className="card-header bg-primary text-white">
                <h5 className="mb-0">Détails de l'article</h5>
              </div>
              <div className="card-body">
                <div className="text-center mb-3">
                  <div className="bg-light rounded d-inline-flex align-items-center justify-content-center p-4">
                    <FontAwesomeIcon
                      icon={faBox}
                      size="3x"
                      className="text-secondary"
                    />
                  </div>
                </div>

                <h5 className="text-primary">{selectedArticle.produit}</h5>
                <p className="text-muted mb-3">{selectedArticle.marque}</p>

                <div className="mb-3">
                  <h6 className="text-muted">INFORMATIONS</h6>
                  <hr className="mt-1" />
                  <div className="row">
                    <div className="col-6 mb-2">
                      <small className="text-muted d-block">ID</small>
                      <span>{selectedArticle.id}</span>
                    </div>
                    <div className="col-6 mb-2">
                      <small className="text-muted d-block">Catégorie</small>
                      <span
                        className={`badge bg-${
                          selectedArticle.categorie === "Informatique"
                            ? "info"
                            : selectedArticle.categorie === "Bureautique"
                            ? "warning text-dark"
                            : "secondary"
                        }`}
                      >
                        {selectedArticle.categorie}
                      </span>
                    </div>
                    <div className="col-6 mb-2">
                      <small className="text-muted d-block">Prix</small>
                      <span className="fw-bold">{selectedArticle.prix}</span>
                    </div>
                    <div className="col-6 mb-2">
                      <small className="text-muted d-block">Stock</small>
                      <span
                        className={`badge ${
                          selectedArticle.stock > 0 ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {selectedArticle.stock} unités
                      </span>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <h6 className="text-muted">DESCRIPTION</h6>
                  <hr className="mt-1" />
                  <p>
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      className="me-2 text-muted"
                    />
                    {selectedArticle.description}
                  </p>
                </div>

                {selectedArticle.specifications?.length > 0 && (
                  <div className="mb-3">
                    <h6 className="text-muted">SPÉCIFICATIONS</h6>
                    <hr className="mt-1" />
                    <ul className="list-unstyled">
                      {selectedArticle.specifications.map((spec, i) => (
                        <li key={i} className="mb-1">
                          <FontAwesomeIcon
                            icon={faCheck}
                            className="text-success me-2"
                          />
                          {spec}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className="d-grid gap-2 mt-4">
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => handleEdit(selectedArticle)}
                  >
                    <FontAwesomeIcon icon={faPen} className="me-2" />
                    Modifier l'article
                  </button>
                  <button
                    className="btn btn-outline-danger"
                    onClick={() => handleDelete(selectedArticle.id)}
                  >
                    <FontAwesomeIcon icon={faTrash} className="me-2" />
                    Supprimer l'article
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="card shadow-sm h-100">
              <div className="card-body d-flex align-items-center justify-content-center">
                <p className="text-muted mb-0">
                  Sélectionnez un article pour afficher les détails
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modal pour ajouter/modifier */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h5>{isEditing ? "Modifier l'article" : "Ajouter un article"}</h5>
              <button className="btn-close" onClick={() => setShowModal(false)}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
              {/* Formulaire */}
              <div className="mb-3">
                <label className="form-label">ID</label>
                <input
                  type="text"
                  className="form-control"
                  value={currentArticle.id}
                  disabled
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Produit</label>
                <input
                  type="text"
                  className="form-control"
                  value={currentArticle.produit}
                  onChange={(e) =>
                    setCurrentArticle({
                      ...currentArticle,
                      produit: e.target.value,
                    })
                  }
                  required
                />
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Marque</label>
                  <input
                    type="text"
                    className="form-control"
                    value={currentArticle.marque}
                    onChange={(e) =>
                      setCurrentArticle({
                        ...currentArticle,
                        marque: e.target.value,
                      })
                    }
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Catégorie</label>
                  <select
                    className="form-select"
                    value={currentArticle.categorie}
                    onChange={(e) =>
                      setCurrentArticle({
                        ...currentArticle,
                        categorie: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="">Sélectionner...</option>
                    {["Informatique", "Bureautique", "Electronique"].map(
                      (cat, i) => (
                        <option key={i} value={cat}>
                          {cat}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Prix (FCFA)</label>
                  <input
                    type="text"
                    className="form-control"
                    value={currentArticle.prix}
                    onChange={(e) =>
                      setCurrentArticle({
                        ...currentArticle,
                        prix: e.target.value,
                      })
                    }
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Stock</label>
                  <input
                    type="number"
                    className="form-control"
                    value={currentArticle.stock}
                    onChange={(e) =>
                      setCurrentArticle({
                        ...currentArticle,
                        stock: parseInt(e.target.value) || 0,
                      })
                    }
                    required
                    min="0"
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={currentArticle.description}
                  onChange={(e) =>
                    setCurrentArticle({
                      ...currentArticle,
                      description: e.target.value,
                    })
                  }
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Spécifications</label>
                {currentArticle.specifications.map((spec, i) => (
                  <div key={i} className="input-group mb-2">
                    <input
                      type="text"
                      className="form-control"
                      value={spec}
                      placeholder="ex: Résolution: 1200x1200 dpi"
                      onChange={(e) => updateSpecification(i, e.target.value)}
                      required
                    />
                    <button
                      className="btn btn-outline-danger"
                      type="button"
                      onClick={() => removeSpecification(i)}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </div>
                ))}
                <button
                  className="btn btn-outline-secondary btn-sm mt-2"
                  type="button"
                  onClick={addSpecification}
                >
                  <FontAwesomeIcon icon={faPlus} className="me-1" />
                  Ajouter une spécification
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Annuler
              </button>
              <button
                className="btn btn-primary"
                onClick={handleSave}
                disabled={
                  !currentArticle.produit ||
                  !currentArticle.marque ||
                  !currentArticle.categorie
                }
              >
                {isEditing ? "Enregistrer" : "Ajouter"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
